/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {DragDropModule} from "@angular/cdk/drag-drop";
import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {FlexLayoutModule} from "@angular/flex-layout";

import {MatIconModule} from "@angular/material/icon";
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";

import {PatterModule} from "./patter/patter.module";
import {PatterTableComponent} from "./patter-table.component";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";

@NgModule({
	declarations: [
		PatterTableComponent,
	],
	imports: [
		CommonModule,
		DragDropModule,

		FlexLayoutModule,

		MatCardModule,
		MatButtonModule,
		MatIconModule,
		MatSlideToggleModule,

		PatterModule,
	],
	exports: [
		PatterTableComponent,
	],
})

export class PatterTableModule {
}
